// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__92zq-","content":"styles_content__23ZfJ","row":"styles_row__3zec1","footer":"styles_footer__H8Bns","phraseLength":"styles_phraseLength__2-ONt"};